// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { tryParseNumber } from '@seedplanner/shared-utils';

export function validateNumInput({
  event,
  setValidationMessage,
  validateInt = false,
  isRequired = false,
  validateLT,
  validateLTE,
  validateGT,
  validateGTE,
  decimals,
}: {
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
  setValidationMessage: (msg: string) => void;
  validateInt?: boolean;
  isRequired?: boolean;
  validateLT?: number;
  validateGT?: number;
  validateLTE?: number;
  validateGTE?: number;
  decimals?: number;
}) {
  if (isRequired && event.target.value === '') {
    setValidationMessage('Value is required');
    return;
  }
  if (!isRequired && event.target.value === '') {
    setValidationMessage('');
    return;
  }

  const maybeNum = tryParseNumber({ value: event.target.value, parseInt: validateInt });
  if (maybeNum === undefined) {
    if (validateInt) {
      setValidationMessage('Value must be an integer');
      return;
    }
    setValidationMessage('Value must be a number');
    return;
  }

  if (validateGTE !== undefined && maybeNum < validateGTE) {
    setValidationMessage(`Value must be greater than or equal to ${validateGTE}`);
    return;
  }
  if (validateGT !== undefined && maybeNum <= validateGT) {
    setValidationMessage(`Value must be greater than ${validateGT}`);
    return;
  }
  if (validateLT !== undefined && maybeNum >= validateLT) {
    setValidationMessage(`Value must be less than ${validateLT}`);
    return;
  }
  if (validateLTE !== undefined && maybeNum > validateLTE) {
    setValidationMessage(`Value must be less than or equal to ${validateLTE}`);
    return;
  }
  if (decimals !== undefined && !validateInt) {
    const valueStr = event.target.value.trim();
    const decMatch = valueStr.match(/\.(\d*)$/);
    if (decMatch && decMatch[1].length > decimals) {
      setValidationMessage(`Value must have no more than ${decimals} decimal place${decimals === 1 ? '' : 's'}`);
      return;
    }
  }
  setValidationMessage('');
}
